const baseURL = process.env.NEXT_PUBLIC_GA_USER_LOG_DELIVERY_URL;
const options = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8', // 필요에 따라 헤더 수정
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  },
};
// 헤더값 참고 안함 응답이 없어서 우리쪽에서는 에러 처리가 계속되서 fetch 따로 호출하게 변경
export const requestLogDelivery = async (
  eventName: string,
  body: unknown,
  user: string
) => {
  fetch(`${baseURL}/event/web/${eventName}`, {
    method: 'POST',
    headers: options.headers,
    body: JSON.stringify({
      event: body,
      user,
    }),
    keepalive: true,
  });
};

export const requestShortFormLogDelivery = async (
  eventName: string,
  body: unknown,
  user: unknown
) => {
  fetch(`${baseURL}/event/web/${eventName}`, {
    method: 'POST',
    headers: options.headers,
    body: JSON.stringify({
      event: body,
      user,
    }),
    keepalive: true,
  });
};
